import React, { useState, useContext, useEffect, useRef } from "react";
import SidebarContext from "../../contexts/MyContext";
import AudioPlayer from "react-h5-audio-player";
import Modal from "../Modal/Modal";
import WaveSurfer from 'wavesurfer.js';
import Waveform from "../Waveform/Waveform";
import { truncateFileName } from "../../utils/truncateFileName";
import { formatTimeWithOptionalHours, timeStringToSeconds } from "../../utils/timeFile";
import WaveFormNew from "../Waveform/WaveFormNew";
import { useTrackNavigation } from "../../utils/trackNavigationUtils";
import { Icon } from "@iconify/react";
import "../../css/app/editTools.css";

const TrimRecordingLogic = () => {
    const { selectedTrimAudio, setTabIndex, setActionTabIndex, setAudio, audioIndex, listTabIndex, setAudioIndex, filterAudioData, favoriteAudio, setSelectedTrimAudio } = useContext(SidebarContext);
    const { isPrevDisabled, isNextDisabled, playPreviousTrack, playNextTrack, } = useTrackNavigation()

    const [openModal, setOpenModal] = useState(false);
    const [recordingName, setRecordingName] = useState();
    const [isPlaying, setIsPlaying] = useState(false);



    // A file picked in AI Tools is not in the recording list yet, so it must not be replaced by it.
    const isLocalUpload = selectedTrimAudio?.isLocalUpload === true;

    // Closing the screen is the only way back out, so the object URL is dropped there.
    const closeTrimScreen = () => {
        if (isLocalUpload) {
            URL.revokeObjectURL(selectedTrimAudio?.audio?.url);
            setSelectedTrimAudio([]);
        }
        setActionTabIndex(null);
        // Back to the trimmed recording's player; an imported file has no player to return to.
        setAudio(isLocalUpload ? undefined : selectedTrimAudio);
    };

    useEffect(() => {
        if (isLocalUpload) return;
        if (selectedTrimAudio) {
            // console.log(selectedTrimAudio,'selectedTrimAudio')
            listTabIndex === 1 ? (

                setSelectedTrimAudio(filterAudioData[audioIndex])
            ) : (
                setSelectedTrimAudio(favoriteAudio[audioIndex])
            )

        }
    }, [audioIndex, filterAudioData, favoriteAudio, listTabIndex, isLocalUpload]);

    const handlePlay = () => {
        setIsPlaying(true);
    };

    const handlePause = () => {
        setIsPlaying(false);
    };

    const handleClose = () => {
        setOpenModal(false);
        setRecordingName("");
    };
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };


    const fileName = selectedTrimAudio?.audio?.fileName;
    const extension = fileName?.includes('.')
        ? fileName.slice(fileName?.lastIndexOf('.') + 1)
        : '';
    return (
        <>
            <div className="vr-edit vr-tone-cyan">
                {selectedTrimAudio?.length == 0 ? (
                    <div className="vr-edit-empty">
                        <img src="/img/trim/trim_img.png" />
                        <h3>
                            Select Recording for Trim
                        </h3>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting
                            industry. Lorem Ipsum has been the industry's
                        </p>
                    </div>
                ) : (
                    <>
                        <div className="vr-edit-head">
                            <span className="vr-icon-tile is-solid"><Icon icon="lucide:scissors" width={20} height={20} /></span>
                            <div className="vr-edit-head-text">
                                <h6 className="vr-edit-title">
                                    Trim
                                </h6>
                                <div className="vr-edit-file">
                                    <Icon icon="lucide:audio-lines" width={16} height={16} />
                                    <h6>
                                        {truncateFileName(selectedTrimAudio?.audio?.fileName, 35)}
                                    </h6>
                                </div>
                            </div>
                            <button type="button" className="vr-iconbtn is-bordered vr-edit-close" aria-label="Close" onClick={closeTrimScreen}>
                                <Icon icon="lucide:x" width={18} height={18} />
                            </button>
                        </div>
                        <WaveFormNew
                            audioName={selectedTrimAudio?.audio?.fileName}
                            audioId={selectedTrimAudio?._id}
                            audioUrl={selectedTrimAudio?.audio?.url}
                            startTime={selectedTrimAudio?.audio?.timeDuration} folderId={selectedTrimAudio?.folderId || selectedTrimAudio?.audio?.folderId ? selectedTrimAudio?.folderId || selectedTrimAudio?.audio?.folderId : ''} selectedTrimAudio={selectedTrimAudio}
                            isPrevDisabled={isLocalUpload || isPrevDisabled}
                            isNextDisabled={isLocalUpload || isNextDisabled}
                            playNextTrack={playNextTrack}
                            playPreviousTrack={playPreviousTrack}

                        />
                        <div>
                            <style>
                                {`
                   
                    .rhap_current-time{
                        top:520px !important;
                        color:#64748B !important
                        }
                    //  .total_audio_time{
                    //       top: 520px;
                        
                    // }
                `}
                            </style>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default TrimRecordingLogic;
